/**
 * Запоминаем, на каком экране человек закрыл приложение, и возвращаем его туда
 * при следующем входе. Раньше вход всегда кидал на главную, даже если человек
 * ушёл из чатов или из ленты.
 *
 * Храним в localStorage: это не секрет, а на сервер гонять лишний запрос незачем.
 */
const KEY = 'lovirds_last_route';
const TTL_MS = 30 * 24 * 60 * 60 * 1000;   // месяц

// Пускаем только свои экраны: чужой путь из хранилища не должен уводить
// приложение неизвестно куда
const ALLOWED_EXACT = ['/', '/lenta', '/match', '/chats', '/quizzes', '/unions'];
const ALLOWED_PREFIX = ['/union/', '/chats/'];

export function isAllowedRoute(path) {
    if (typeof path !== 'string' || !path.startsWith('/')) return false;
    if (ALLOWED_EXACT.includes(path)) return true;
    return ALLOWED_PREFIX.some((prefix) => path.startsWith(prefix));
}

export function saveLastRoute(path) {
    if (!isAllowedRoute(path)) return;
    try {
        localStorage.setItem(KEY, JSON.stringify({ path, savedAt: Date.now() }));
    } catch (_e) { /* приватный режим — не критично */ }
}

/** Последний экран или null, если его нет, он протух или запрещён. */
export function getLastRoute() {
    try {
        const raw = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (!raw?.path || Date.now() - (raw.savedAt || 0) > TTL_MS) return null;
        return isAllowedRoute(raw.path) ? raw.path : null;
    } catch (_e) {
        return null;
    }
}

export function clearLastRoute() {
    try { localStorage.removeItem(KEY); } catch (_e) { /* ignore */ }
}
